// Checked

import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
// import user5up from "/images/user5up.svg";
// import lockIcon from "/images/lockIcon.svg";
// import Button from "@material-ui/core/Button";

import ProfileSettings from './ProfileSettings';
import PasswordSettings from './PasswordSettings';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';

const useStyles = makeStyles(() => ({
  root: {
    background: 'white',
    borderRadius: '5px',
    boxShadow: '0px 0px 2px 1px rgba(0, 0, 0, .05)',
    marginBottom: '40px',
  },
  rootChildStyle: {
    padding: '30px 20px',
  },
  borderStyle: {
    borderRight: '2px solid rgba(0, 0, 0, .05)',
  },

  title: {
    marginBottom: 20,
  },
  marginRightStyle: {
    marginRight: 15,
  },
  marginRightStyle2: {
    marginRight: 19,
  },
  listItemStyle: {
    cursor: 'pointer',
    padding: '10px 15px',
    marginBottom: '10px',
    borderRadius: '8px',
    '&:hover': {
      background: 'rgba(255, 235, 185, 0.7)',
    },
  },
  active: {
    cursor: 'pointer',
    padding: '10px 15px',
    background: 'rgba(255, 235, 185, 1)',
    marginBottom: '10px',
    borderRadius: '8px',
    '&:hover': {
      background: 'rgba(255, 235, 185, 1)',
    },
  },
  menuFontStyle: {
    fontSize: 16,
    color: '#474645',
    marginLeft: 10,
    cursor: 'pointer',
  },
}));

const AccountSettings = () => {
  let history = useHistory();
  const { search } = useLocation();
  const classes = useStyles();
  const [active, setActive] = useState('ProfileSettings');
  const values = queryString.parse(search);
  // console.log('search', values.com);
  useEffect(() => {
    if (values.com === 'password-settings') {
      setActive('PasswordSettings');
    }
  }, []);
  return (
    <React.Fragment>
      <Typography variant="h4" className={classes.title}>
        Account Settings
      </Typography>
      <div className={classes.root}>
        <Grid container>
          <Grid item xs={4} className={`${classes.rootChildStyle} ${classes.borderStyle}`}>
            <Grid
              container
              alignItems="center"
              className={active === 'ProfileSettings' ? classes.active : classes.listItemStyle}
              onClick={() => {
                setActive('ProfileSettings');
                history.push({ search: '?com=profile-settings' });
              }}>
              <img src="/images/user5up.svg" alt="" className={classes.marginRightStyle} />{' '}
              <label className={classes.menuFontStyle}>Profile Settings</label>
            </Grid>
            <Grid
              container
              alignItems="center"
              className={active === 'PasswordSettings' ? classes.active : classes.listItemStyle}
              onClick={() => {
                setActive('PasswordSettings');
                history.push({ search: '?com=password-settings' });
              }}>
              <img src="/images/lockIcon.svg" alt="" className={classes.marginRightStyle2} />
              <label className={classes.menuFontStyle}> Password Settings</label>
            </Grid>
          </Grid>
          <Grid item xs={8} className={classes.rootChildStyle}>
            {active === 'ProfileSettings' && <ProfileSettings />}
            {active === 'PasswordSettings' && <PasswordSettings />}
          </Grid>
        </Grid>
      </div>
    </React.Fragment>
  );
};

export default AccountSettings;
